export default __webpack_public_path__ + "static/media/program-info-icon-active.2d771d9e.svg";